import type { ReactNode } from 'react';

import type { StatusTone } from '../utils/run-status';
import { humanizeEnum } from '../utils/run-status';

import { StatusBadge } from './ui-kit/status-badge';

interface ContentStatusChipProps {
  /** Raw status straight off the wire — humanised here rather than by the caller. */
  status: string;
  tone: StatusTone;
  /** Plain words to show instead of the humanised status (e.g. "Running" for GENERATING). */
  label?: string;
  /** Pulse the dot to signal a live / still-moving run. */
  pulse?: boolean;
  /** Plain-language meaning, shown on hover/focus. */
  explanation?: ReactNode;
  className?: string;
}

/**
 * Status badge for job, batch and task statuses — a thin adapter over the kit's
 * `StatusBadge` that humanises the raw enum, so every status looks the same.
 */
export function ContentStatusChip({
  status,
  tone,
  label,
  pulse = false,
  explanation,
  className,
}: ContentStatusChipProps) {
  return (
    <StatusBadge
      label={label ?? humanizeEnum(status)}
      tone={tone}
      pulse={pulse}
      {...(explanation !== undefined && { explanation })}
      {...(className !== undefined && { className })}
    />
  );
}
